/* @flow */
// typecheck: ignore file
import Button from 'components/Button.jsx';
import Field from 'components/Field.jsx';
import Label from 'components/Label.jsx';
import React from 'react';
import RelationshipActions from 'actions/RelationshipActions';
import Subscriber from 'entities/Subscriber';
import Textarea from 'components/Textarea.jsx';
import ToastActions from 'actions/ToastActions';

class RelationshipViewNotes extends React.Component {
  static propTypes = {
    subscriber: React.PropTypes.instanceOf(Subscriber).isRequired,
  };

  state = {
    note: this.props.subscriber.getNote(),
  };

  handleNoteChange = (event: SyntheticEvent) => {
    // $FlowIssue
    this.setState({ note: event.target.value });
  };

  handleUpdateNote = () => {
    RelationshipActions
      .updateNote(this.props.subscriber.id, this.state.note)
      .then(() => {
        ToastActions.showSuccessToast('Notes saved');
      }).catch(() => {
        ToastActions.showErrorToast('An error has occurred');
      });
  };

  render() {
    const { subscriber } = this.props;
    const placeholder = `Add a note about ${subscriber.getName()} (only you can see this)`;

    return (
      <div className="RelationshipViewNotes">
        <Field>
          <Label htmlFor="">Notes</Label>
          <Textarea
            value={this.state.note}
            placeholder={placeholder}
            ref="note"
            autogrow
            rows={2}
            onChange={this.handleNoteChange}
          />
        </Field>
        <Button
          size="xsmall"
          className="pull-right"
          disabled={this.state.note === subscriber.getNote()}
          onClick={this.handleUpdateNote}
          eventElementName="pull-right">
          Save
        </Button>
      </div>
    );
  }
}

export default RelationshipViewNotes;



// WEBPACK FOOTER //
// ./src/user/components/RelationshipViewNotes.jsx